var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 15.3006L0.275 8.70057C0.175 8.60057 0.104 8.49224 0.0619998 8.37557C0.0206665 8.2589 0 8.1339 0 8.00057C0 7.86724 0.0206665 7.74224 0.0619998 7.62557C0.104 7.5089 0.175 7.40057 0.275 7.30057L6.875 0.700571C7.05833 0.517237 7.28733 0.421238 7.562 0.412571C7.83733 0.404571 8.075 0.500571 8.275 0.700571C8.475 0.883904 8.57933 1.1129 8.588 1.38757C8.596 1.6629 8.5 1.90057 8.3 2.10057L3.4 7.00057H14.575C14.8583 7.00057 15.096 7.09624 15.288 7.28757C15.4793 7.47957 15.575 7.71724 15.575 8.00057C15.575 8.2839 15.4793 8.52124 15.288 8.71257C15.096 8.90457 14.8583 9.00057 14.575 9.00057H3.4L8.3 13.9006C8.48333 14.0839 8.57933 14.3172 8.588 14.6006C8.596 14.8839 8.5 15.1172 8.3 15.3006C8.11667 15.5006 7.88333 15.6006 7.6 15.6006C7.31667 15.6006 7.075 15.5006 6.875 15.3006Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSvg);
export default __webpack_public_path__ + "static/media/BackSvg.9dbe8e36.svg";
export { ForwardRef as ReactComponent };